
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    root: {
        height: '100%',
        width: '1024px',
        //overflowY: 'auto'
    },

    footer: {
        padding: '1em 0em'
    },

    label: {
        borderBottom: '1px solid black'
    },

    scrollable: {
        //overflowY: 'auto'
    },

    btnBox: {
        display: 'flex',
        justifyContent: 'space-between'
    },

    btn: {
        width: '49%'
    }
});

const UsekAttrsPageView = ({
    canContinue,
    onGoNextClick,
    onGoBackClick,
    usekAttributes,
    usekSelector,
    validator
}) => {

    const handleGoNextClick = () => {
        if (onGoNextClick) {
            onGoNextClick();
        }
    }

    const handleGoBackClick = () => {
        if (onGoBackClick) {
            onGoBackClick();
        }
    }

    const continueIco = { iconName: 'TriangleRight12' };
    const previousIco = { iconName: 'TriangleLeft12' };

    return (
        <Stack verticalFill className={classNames.root}>
            <Stack.Item>
                <h3 className={classNames.label}>Zadání vlastností mezí</h3>
            </Stack.Item>
            <Stack.Item>
                {usekSelector}
            </Stack.Item>
            <Stack.Item grow className={classNames.scrollable}>
                {usekAttributes}
            </Stack.Item>
            <Stack.Item className={classNames.footer}>
                {validator}
                <Stack horizontal className={classNames.btnBox}>
                    <PrimaryButton
                        className={classNames.btn}
                        iconProps={previousIco}
                        onClick={handleGoBackClick}
                    >
                        Zpět na zadání úseků mezí
                    </PrimaryButton>
                    {canContinue &&
                        <PrimaryButton
                            className={classNames.btn}
                            iconProps={continueIco}
                            onClick={handleGoNextClick}
                        >
                            Pokračovat na výběr ceníku
                        </PrimaryButton>
                    }
                </Stack>
            </Stack.Item>
        </Stack>
    )
}

export default UsekAttrsPageView;
